module.exports = __webpack_public_path__ + "static/media/change_term.8edc7216.png";